define(['jquery',
        'core/urls',
        'core/dynamic-forms'],
    function($, urls) {

        function kaseyaConnectivityCheck(){
            $.ajax({
                type: 'GET',
                url: urls['ticketsource:kaseya-connectivity'](),
                dataType: 'json',
                success: function(data){
                     if(data.status === 'connected'){
                        $('#connectivity-status-checking-kaseya').hide();
                        $('#connectivity-status-kaseya p').hide();
                        $('#connectivity-status-connected-kaseya').show();
                        $('#connectivity-status-notconnected-kaseya').hide();
                    } else if(data.status === 'disconnected') {
                        $('#connectivity-status-checking-kaseya').hide();
                        $('#connectivity-status-notconnected-kaseya').show();
                        $('#connectivity-status-connected-kaseya').hide();
                        $('#connectivity-status-kaseya p').show();
                    }
                }
            });
        }

        return {
            init: function() {
                kaseyaConnectivityCheck();
                $(document).on('valid', 'form', function() {
                    kaseyaConnectivityCheck();
                    if(!globals.has_generated_snippet) {
                        $('#continueToSurveyButton').prop('disabled', false);
                        $('#skipApiSetupLink').hide();
                    }
                });
            }
        };
    }
);